module.exports = __webpack_public_path__ + "static/media/Daybook.1ebe948a.png";